import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowDown, Zap, Shield, Smartphone } from 'lucide-react';

export const HeroSection = () => {
  const scrollToTool = () => {
    const toolSection = document.getElementById('converter-tool');
    if (toolSection) {
      toolSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative overflow-hidden gradient-hero">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 rounded-full bg-accent/5 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-32 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <Badge variant="secondary" className="mb-6 px-4 py-1.5 text-sm font-medium bg-primary/10 text-primary border-0 hover:bg-primary/15 transition-colors">
            Free • No signup • Unlimited conversions
          </Badge>

          {/* Headline - Using div instead of h1 since main H1 is in the tool section */}
          <div className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight tracking-tight mb-6 animate-fade-in-up">
            Convert Text Case{' '}
            <span className="gradient-text">Instantly</span>
          </div>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 leading-relaxed" style={{ animationDelay: '0.1s' }}>
            Transform your text between sentence case, UPPERCASE, lowercase, Title Case, and more. 
            No limits, no sign-up, works entirely in your browser.
          </p>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12" style={{ animationDelay: '0.2s' }}>
            <Button 
              size="xl" 
              variant="premium"
              onClick={scrollToTool}
              className="group"
            >
              Start Converting Now
              <ArrowDown className="h-4 w-4 ml-1 group-hover:translate-y-0.5 transition-transform" />
            </Button>
            <span className="text-sm text-muted-foreground">
              Works instantly — no waiting
            </span>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Zap className="h-4 w-4 text-primary" />
              <span>Lightning fast</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-primary" />
              <span>100% private</span>
            </div>
            <div className="flex items-center gap-2">
              <Smartphone className="h-4 w-4 text-primary" />
              <span>Mobile friendly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
